var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTailwindcss(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 70.332,
    height: 42.188,
    viewBox: "0 0 70.332 42.188",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "tailwindcss",
    d: "M35.316.13Q21.249.13,17.733,14.192q5.276-7.031,12.308-5.273c2.675.668,4.587,2.609,6.7,4.757,3.448,3.5,7.438,7.548,16.154,7.548q14.066,0,17.583-14.063-5.274,7.031-12.308,5.274c-2.674-.668-4.586-2.609-6.7-4.757C48.023,4.179,44.032.13,35.316.13ZM17.733,21.223Q3.667,21.223.15,35.286q5.274-7.031,12.308-5.273c2.674.669,4.586,2.609,6.7,4.756,3.448,3.5,7.439,7.549,16.154,7.549q14.067,0,17.583-14.063-5.276,7.031-12.308,5.273c-2.675-.668-4.587-2.609-6.7-4.756C30.439,25.273,26.449,21.223,17.733,21.223Z",
    transform: "translate(-0.15 -0.13)",
    fill: "#06b6d4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTailwindcss);
export default __webpack_public_path__ + "static/media/tailwindcss.a4ba77882396995268f0d2cef780b279.svg";
export { ForwardRef as ReactComponent };